import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/reports/withdrawalRequestsComissions/filter'; // Importing Filter component
import Table from 'views/reports/withdrawalRequestsComissions/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view for bet shops.
 */
export default class withdrawalRequestsBetShopView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + _('Retiros'),
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Retiros'),
                                    ignore: {
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Retiros'),
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Retiros'),
                                        autowidth: true,
                                        ignore: {
                                            Action: true,
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            view: 'label', // Label for report title
                            label: screen == 'small' ? _('Reporte de comisiones') : _('Reporte de comisiones pagadas'),
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon', // Icon for search action
                                    icon: 'wxi-search',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        // Click event to show filter popup
                                        $$('filterPopup').show();
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form', // Form view for the main layout
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section containing toolbar, filter, and table
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            $.fn.scrollBottom = function () {
                // jQuery function to get scroll bottom position
                return $$(document).height() - this.scrollTop() - this.height();
            };
            if (screen.width < 500 || screen.height < 500) {
                // Adjust layout for small screens
                var childs = $$('toolbar').getChildViews();
                $$('toolbar').removeView(childs[2]); // Remove export dropdown for small screens
                $$('pagerA').define('group', 1); // Group pager for small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                // Hide search button for larger screens
                $$('button-search').hide();
            }
        });
    }
}

// FILE DOCUMENTED
